import React from "react";
import { Box, Chip } from "@mui/material";
import SettingsEthernetIcon from "@mui/icons-material/SettingsEthernet";
import { useSelector } from "react-redux";
import { formatDistance } from "./handleActionsMaps";

const TooltipDistandeAndTime = () => {
  const { route } = useSelector((state) => state.routeReducer);
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        position: "absolute",
        top: 20,
        right: 70,
        zIndex: 1,
      }}
    >
      <Chip
        label={`${formatDistance(route?.distance ?? 0)}`}
        avatar={<SettingsEthernetIcon style={{ color: "black" }} />}
        style={{
          backgroundColor: "#e7ef7d",
          color: "black",
          boxShadow: "0px 1px 15px 2px rgba(0,0,0,0.7)",
        }}
      />
    </Box>
  );
};

export default TooltipDistandeAndTime;
